const data = {
  projects: [
    {
      _id: "project-0",
      number: 0,
      name: "Peer Pressure",
      role: "Full-Stack Software Engineer",
      tech: "React, Next.js, Typescript, Prisma, PostgreSQL, NextAuth, TailwindCSS, WebSockets",
      image: "/images/peer_pressure.png",
      date: "November 2025",
      dateShort: "11/2025",
      description:
        "Peer Pressure is a social accountability application that allows you to plan today and tomorrow's daily tasks and view your friends' tasks to promote peer motivation and accountability.",
      link: "https://peer-pressure-virid.vercel.app/",
      action: "Go to Project",
      active: true,
    },
    {
      _id: "project-1",
      number: 1,
      name: "PowerAI",
      role: "Full-Stack Software Engineer",
      tech: "OpenAI, RAG, Prompt Engineering, Python, FastAPI, React, FAISS, PostgreSQL",
      image: "/images/power_ai.png",
      date: "August 2025",
      dateShort: "8/2025",
      description:
        "PowerAI is an AI-powered strength training analytics platform that helps athletes, bodybuilders, and powerlifters make sense of their workout history.",
      link: "https://power-ai-chi.vercel.app/",
      action: "Go to Project",
      active: true,
    },
    {
      _id: "project-2",
      number: 2,
      name: "Virus Shooter",
      role: "Main Developer",
      tech: "Unity3D, C#",
      image: "/images/virus_shooter.png",
      date: "April 2021",
      dateShort: "4/2021",
      description:
        "A fast-paced Unity game created for a VR course at UC San Diego, where players must shoot as many mutant viruses as possible before time runs out. Inspired by the COVID-19 pandemic, this project introduced me to core game development concepts and mechanics.",
      link: "https://nmakucsd.github.io/Virus_Shooter/index.html",
      action: "PLAY",
      active: true,
    },
    {
      _id: "project-3",
      number: 3,
      name: "BulkUP E-commerce Web App",
      role: "Developer and Designer",
      tech: "MongoDB, Express, React, Node.js",
      image: "/images/BulkUP.png",
      date: "September 2020 - April 2021",
      dateShort: "9/2020 - 4/2021",
      description:
        "A full-stack e-commerce platform connecting produce sellers with restaurants and businesses, eliminating the middleman for better pricing and business opportunities. Built with the MERN stack, it features user authentication, product listings, and location-based search.",
      link: "https://my-bulkup-app.herokuapp.com/",
      action: "VISIT SITE",
      active: true,
    },
    {
      _id: "project-4",
      number: 4,
      name: "Wear a Mask!",
      role: "Main Developer",
      tech: "Unity3D, C#",
      image: "/images/WearAMask.png",
      date: "January 2021",
      dateShort: "1/2021",
      description:
        "A Unity-based educational game designed to promote social distancing and mask-wearing. Players must encourage NPCs to wear masks before they get too close, simulating the importance of public health measures in a pandemic scenario.",
      link: "https://nmakucsd.github.io/Wear_A_Mask/index.html",
      action: "PLAY",
      active: true,
    },
    {
      _id: "project-5",
      number: 5,
      name: "Jelly Bumper",
      role: "Main Developer",
      tech: "Unity3D, C#",
      image: "/images/JellyBumpers.png",
      date: "November 2020",
      dateShort: "11/2020",
      description:
        "A 3rd-person Unity game developed to kick off TritonXR's Unity workshop series. Players use physics-based mechanics to bump 'Jellies' off the map, learning about collision and movement in game development.",
      link: "https://nmakucsd.github.io/JellyBump/index.html",
      action: "PLAY",
      active: true,
    },
    {
      _id: "project-6",
      number: 6,
      name: "Tetris (Desktop)",
      role: "Developer",
      tech: "HTML, CSS, JavaScript",
      image: "/images/Tetris.png",
      date: "January 2020",
      dateShort: "1/2020",
      description:
        "A classic Tetris game implemented in vanilla JavaScript, created to deepen my understanding of the language and core web development concepts.",
      link: "https://nmakucsd.github.io/Tetris/",
      action: "PLAY",
      active: true,
    },
    {
      _id: "project-7",
      number: 7,
      name: "Rock Paper Scissors Lizard Spock",
      role: "Developer",
      tech: "HTML, CSS, JavaScript",
      image: "/images/RPSLS.png",
      date: "November 2019",
      dateShort: "11/2019",
      description:
        "An enhanced version of the classic Rock Paper Scissors game, inspired by 'The Big Bang Theory.' Built as an introduction to JavaScript state management, it allows players to compete against a computer opponent with an updated scoreboard.",
      link: "https://nmakucsd.github.io/RockPaperScissorsLizardSpock/",
      action: "PLAY",
      active: true,
    },
    {
      _id: "project-8",
      number: 8,
      name: "SOTA Cyberdragons Robotics Team",
      role: "Founder, Programmer, Mechanical Engineer",
      tech: "Java, Python, OpenCV",
      image: "/images/SOTACyberdragons.png",
      date: "August 2014 - December 2017",
      dateShort: "8/2014 - 12/2017",
      description:
        "Founded and led a high school robotics team in San Francisco, participating in FIRST competitions. Managed programming, mechanical engineering, and team operations, fostering STEM skills and leadership among members.",
      link: "http://www.team5700.org/",
      action: "VISIT SITE",
      active: true,
    },
  ],
  experiences: [
    {
      _id: "experience-0",
      number: 0,
      name: "Microsoft",
      role: "Software Engineer",
      tech: "React.js, Angular, Dotnet, Azure Cloud, SQL Server, Azure Copilot (AI)",
      image: "/images/Microsoft.png",
      date: "May 2022 - Present",
      dateShort: "5/2022 - Present",
      description:
        "Currently working as a Software Engineer at Microsoft in the Experiences & Devices division, contributing to XPay and Bing Ads projects. Responsibilities include developing scalable solutions and collaborating with cross-functional teams.",
      link: "https://ads.microsoft.com/",
      action: "VISIT SITE",
      active: true,
    },
    {
      _id: "experience-1",
      number: 1,
      name: "Microsoft (Internship)",
      role: "Software Engineer Intern",
      tech: "Databricks, Apache Spark, Scala, Azure Cloud",
      image: "/images/Microsoft.png",
      date: "June 2021 - September 2021",
      dateShort: "6/2021 - 9/2021",
      description:
        "Interned at Microsoft in the Experiences & Devices division, working on Bing Ads. Gained hands-on experience in large-scale software development and agile methodologies.",
      link: "https://ads.microsoft.com/",
      action: "VISIT SITE",
      active: true,
    },
    {
      _id: "experience-2",
      number: 2,
      name: "Toasty",
      role: "Software Engineering Intern",
      tech: "Flutter, Ruby on Rails",
      image: "/images/Toasty.png",
      date: "January 2020 - April 2020",
      dateShort: "1/2020 - 4/2020",
      description:
        "Worked at Toasty, a startup focused on building a mobile app to facilitate meaningful social connections at events. Developed features using Flutter and Ruby on Rails, and contributed to user experience improvements.",
      link: "",
      action: "NDA",
      active: false,
    },
    {
      _id: "experience-3",
      number: 3,
      name: "Triton XR",
      role: "Main Software Developer",
      tech: "HTML, CSS, React, Javascript",
      image: "/images/TritonXR.png",
      date: "November 2019 - February 2021",
      dateShort: "1/2020 - 2/2021",
      description:
        "Led web development for Triton XR, a UC San Diego student organization dedicated to XR technologies. Maintained and upgraded the organization's website, and supported workshops and community events.",
      link: "https://tritonxr.ucsd.edu/",
      action: "VISIT SITE",
      active: true,
    },
    {
      _id: "experience-4",
      number: 4,
      name: "BulkUP E-commerce Web App",
      role: "Developer and Designer",
      tech: "MongoDB, Express, React, Node.js",
      image: "/images/BulkUP.png",
      date: "December 2020 - April 2021",
      dateShort: "12/2020 - 4/2021",
      description:
        "Developed and designed a MERN stack e-commerce platform connecting local produce sellers with buyers. Implemented core features such as authentication, product management, and responsive UI.",
      link: "https://my-bulkup-app.herokuapp.com/",
      action: "This Site is no longer active",
      active: false,
    },
    {
      _id: "experience-5",
      number: 5,
      name: "Robolink",
      role: "Robotics Instructor",
      tech: "Python, RobotC, Vex Robotics",
      image: "/images/Robolink.png",
      date: "November 2019 - May 2020",
      dateShort: "11/2019 - 5/2020",
      description:
        "Taught robotics and programming to elementary and middle school students, preparing them for VEX IQ competitions. Covered topics in Python, RobotC, and robotics fundamentals, fostering STEM interest in young learners.",
      link: "https://shop.robolink.com/",
      action: "VISIT SITE",
      active: true,
    },
    {
      _id: "experience-6",
      number: 6,
      name: "IEEE",
      role: "Project Lead",
      tech: "Onshape, C++, grSim, SLL-Vision",
      image: "/images/IEEE.png",
      date: "October 2019 - February 2020",
      dateShort: "10/2019 - 2/2020",
      description:
        "Led the RoboCup Soccer project at IEEE@UCSD, guiding a team to build autonomous soccer robots and develop AI strategies for competitive play. Managed both hardware and software development.",
      link: "",
      action: "IEEE Robocup 2020 is no longer active",
      active: false,
    },
    {
      _id: "experience-7",
      number: 7,
      name: "The Taylor Collaboration",
      role: "Engineering Intern",
      tech: "G Code",
      image: "/images/TC.png",
      date: "May 2017 - July 2017",
      dateShort: "5/2017 - 7/2017",
      description:
        "Interned at The Taylor Collaboration, an orthopedic research and development lab. Assisted with engineering tasks and gained experience in G Code and laboratory research processes.",
      link: "https://thetaylorcollaboration.jimdofree.com/",
      action: "Visit Site",
      active: true,
    },
  ],
};
export default data;
